var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6194 19.9732L1.53149 1.94306C1.33988 1.75205 1.02921 1.75205 0.8376 1.94306L0.143709 2.63473C-0.0479031 2.82573 -0.0479031 3.1354 0.143709 3.3264L18.2316 21.3566C18.4232 21.5476 18.7339 21.5476 18.9255 21.3566L19.6194 20.6649C19.811 20.4739 19.811 20.1642 19.6194 19.9732ZM0.5 18.6724V7.0738L13.0555 19.6506H1.47825C0.962536 19.6506 0.540028 19.2516 0.502683 18.7455L0.5 18.6724ZM17.6195 14.7282L17.6888 14.7976L21.3702 16.8054C22.0875 17.1966 22.9999 16.727 22.9999 15.9667V7.68386C22.9999 6.92353 22.0875 6.4539 21.3702 6.84508L17.6195 8.89073V14.7282ZM6.90939 3.99983L16.152 13.2582V4.978L16.1494 4.905C16.112 4.39886 15.6895 3.99983 15.1738 3.99983H6.90939Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOff);
export default __webpack_public_path__ + "static/media/CameraOff.8886a02a9702ff33caf9c04b01c9c4c3.svg";
export { ForwardRef as ReactComponent };